import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import MobileBottomNav from "./MobileBottomNav";
import FloatingWhatsAppButton from "./FloatingWhatsAppButton";

const pageMeta = {
  "/": {
    title: "Online Quran Universe | Online Quran Academy",
    description:
      "Live 1:1 online Quran classes for kids and adults. Noorani Qaida, Tajweed, Hifz, and Islamic Studies.",
  },
  "/academy": {
    title: "Our Academy | Online Quran Universe",
    description:
      "Learn about Online Quran Universe — certified teachers, flexible scheduling, and celestial-focused Islamic education.",
  },
  "/programs": {
    title: "Programs | Online Quran Universe",
    description:
      "Explore online Quran programs: Noorani Qaida, Quran Reading, Tajweed, Hifz, Tafseer, and Islamic Studies.",
  },
  "/programs/noorani-qaida": {
    title: "Noorani Qaida Program | Online Quran Universe",
    description:
      "Master Arabic letters and phonics with our Noorani Qaida program for beginners and children.",
  },
  "/programs/quran-reading": {
    title: "Quran Reading Program | Online Quran Universe",
    description:
      "Transition from basic letters to fluent recitation. Learn Quran reading with correct flow and confidence.",
  },
  "/programs/tajweed": {
    title: "Tajweed Mastery Program | Online Quran Universe",
    description:
      "Master the science of beautiful recitation. Learn makharij, elongation, and vocal rules with expert teachers.",
  },
  "/programs/hifz": {
    title: "Hifz Program | Online Quran Universe",
    description:
      "Memorize the Holy Quran with structured revision plans and expert Hifz tutors.",
  },
  "/programs/tafseer": {
    title: "Quran Tafseer Program | Online Quran Universe",
    description:
      "Understand the translation, context, and practical wisdoms of the Quranic verses with our scholars.",
  },
  "/programs/islamic-studies": {
    title: "Islamic Studies Program | Online Quran Universe",
    description:
      "A comprehensive guide to Fiqh, Seerah, Akhlaq, and Hadith for a balanced spiritual life.",
  },
  "/pricing": {
    title: "Pricing | Online Quran Universe",
    description:
      "Simple, transparent Quran class pricing. Starter, Regular, Advanced, and Family plans.",
  },
  "/blog": {
    title: "Quran Learning Resources | Online Quran Universe Blog",
    description:
      "Guides and insights on Tajweed, Hifz, and supporting your Quran learning journey.",
  },
  "/contact": {
    title: "Contact Us | Online Quran Universe",
    description:
      "Contact Online Quran Universe for a free trial class. WhatsApp, email, and inquiry form available 24/7.",
  },
};

export default function Layout() {
  const { pathname } = useLocation();
  const meta = pageMeta[pathname] || pageMeta["/"];

  useEffect(() => {
    document.title = meta.title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", meta.description);
    window.scrollTo(0, 0);
  }, [pathname, meta.title, meta.description]);

  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-primary focus:text-on-primary focus:px-4 focus:py-2 focus:rounded-full"
      >
        Skip to main content
      </a>
      <Header />
      <main
        id="main-content"
        className="flex-1 pb-[calc(4.5rem+env(safe-area-inset-bottom))] md:pb-0"
      >
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsAppButton />
      <MobileBottomNav />
    </div>
  );
}
